import { render, staticRenderFns } from "./SearchResultCard.vue?vue&type=template&id=3c88d952"
import script from "./SearchResultCard.vue?vue&type=script&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&lang=js"
import style0 from "./SearchResultCard.vue?vue&type=style&index=0&id=3c88d952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports